// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"782":"eb4c356f","831":"112d0cd2"}[chunkId] + ".chunk.js";
};